/**
 * Admin: gates the whole /admin/* tree, then hands it to AdminLayout (the
 * shared header and tab bar, features/admin/AdminLayout.tsx).
 *
 * The backend answers 404 (never 403) to a non-admin on every /api/admin/*
 * route, so a non-admin cannot tell "not allowed" from "does not exist"
 * (docs/parity/admin.md §2). This route matches that with `notFound()`,
 * which renders __root.tsx's own "Page not found" rather than a "you're not
 * allowed" screen or a redirect that would itself reveal the route exists.
 *
 * Also gated out while impersonating: `session.impersonator` non-null means
 * the API sees the *target* as the current user. Gate on
 * `is_admin && impersonator === null`, full stop.
 */
import { createFileRoute, notFound } from '@tanstack/react-router';
import { AdminLayout } from '@/features/admin/AdminLayout';
import { sessionQuery } from '@/lib/session';

export const Route = createFileRoute('/_app/admin')({
  beforeLoad: async ({ context }) => {
    const s = await context.queryClient.ensureQueryData(sessionQuery);
    if (!s.user?.is_admin || s.impersonator) {
      throw notFound();
    }
  },
  component: AdminLayout,
});
